import React from 'react';
import PieChart from './PieChart';

const DataSummary = (props) => {
  return (
    <div class="container">
      <h3>Anthrax Cases Statistics</h3>
      <PieChart />
    </div>
  );
}

export default DataSummary;